// client/src/components/admin/cps/CPSSettlementReservationSummary.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function CPSSettlementReservationSummary({ interactive = false }) {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  // 승인 대기 중인 예약 목록 조회 (최대 5개)
  const fetchReservations = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/cps-settlements/reservations?status=pending`, {
        credentials: 'include'
      });
      const data = await res.json();
      
      if (data.ok) {
        const list = data.reservations || [];
        setCount(list.length);
        setReservations(list.slice(0, 5)); // 최대 5개만
      }
    } catch (error) {
      console.error('예약 목록 조회 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReservations();
  }, []);

  // 날짜 포맷팅
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
  };

  return (
    <div className="cps-settlement-reservation-summary">
      {/* 헤더 */}
      <div className="cps-settlement-reservation-summary__header">
        <h3 className="cps-settlement-reservation-summary__title">
          구매당 리워드 결산 미진행건 처리
        </h3>
        {count > 0 && (
          <span className="cps-settlement-reservation-summary__badge cps-settlement-reservation-summary__badge--pending">
            {count}
          </span>
        )}
      </div>

      {/* 로딩 */}
      {loading && (
        <div className="cps-settlement-reservation-summary__loading">
          로딩 중...
        </div>
      )}

      {/* 목록 */}
      {!loading && reservations.length === 0 && (
        <div className="cps-settlement-reservation-summary__empty">
          처리할 결산 건이 없습니다.
        </div>
      )}

      {!loading && reservations.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {reservations.map((reservation) => (
            <div
              key={reservation._id}
              style={{
                padding: 16,
                background: '#f9fafb',
                borderRadius: 8,
                border: '1px solid #e5e7eb'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ 
                    fontSize: 14, 
                    fontWeight: 600, 
                    color: '#111827',
                    marginBottom: 4
                  }}>
                    Project No: {reservation.projectNumber || 'N/A'}
                  </div>
                  <div style={{ fontSize: 12, color: '#6b7280' }}>
                    {reservation.marketerName || '알 수 없음'}
                  </div>
                  <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
                    {reservation.roundNumber}회차 • 자동예약: {formatDate(reservation.autoReservedAt)}
                  </div>
                </div>
                <div className="cps-settlement-reservation-summary__badge cps-settlement-reservation-summary__badge--pending">
                  승인대기
                </div>
              </div>
            </div>
          ))}
          
          {count > 5 && (
            <div style={{ textAlign: 'center', fontSize: 12, color: '#6b7280', marginTop: 8 }}>
              외 {count - 5}건 더 있습니다
            </div>
          )}
        </div>
      )}
    </div>
  );
}

